<template>
    <!-- TODO 200% c'est sale -->
    <div class="modal-card" style="width: 200%">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="handshake" class="m-2"></b-icon>
                Ajout d'un financeur
            </p>
        </header>
        <section class="modal-card-body">

            <b-field label="Financeur">


                <b-autocomplete
                    v-model="filterBox"
                    placeholder="Nom du financeur"
                    keep-first
                    :data="filteredDataObj"
                    field="name"
                    open-on-focus
                    @select="option => (payload.fi = option)"
                    clearable>
                    <template slot-scope="props">
                        <div class="media-content">
                            {{ props.option }}
                        </div>
                    </template>

                </b-autocomplete>

            </b-field>

            <b-field label="Prise en charge en €">
                <b-input
                    type="number"
                    min="0"
                    step="any"
                    v-model="payload.cost"
                    @input="calcPercent()"
                >
                </b-input>
            </b-field>
            <b-field label="Prise en charge en % du total du projet">
                <div class="columns">
                    <div class="column">
                        <b-input
                            type="number"
                            min="0"
                            step="any"
                            v-model="payload.percent"
                            @input="calcEuro()"
                        >
                        </b-input>
                    </div>
                    <div class="column">
                        <!-- Lock percentages -->
                        <b-switch
                            v-model="payload.pclock"
                        >
                            {{ payload.pclock ? 'Taux bloqué' : 'Bloquer le taux' }}
                        </b-switch>
                        <b-icon
                            v-if="payload.pclock"
                            icon="lock"
                            size="is-medium">
                        </b-icon>

                    </div>
                </div>
            </b-field>

            <!-- Taux de prise en charge des frais généraux -->
            <b-field label="Prise en charge des frais généraux">
                <b-input type="text"
                         v-model="payload.tauxfg"
                         placeholder="en %"
                         @input="calcEuro()"
                >
                </b-input>
            </b-field>

            <b-field label="Commentaire">
                <b-input type="text"
                         v-model="payload.comment"
                         placeholder="Commentaire">
                </b-input>
            </b-field>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="addFI">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
export default {
    name: "FINAddModal",
    props: {
        refFI: {
            type: Array,
            required: true
        },
        totalCostProjectSansFG: {
            type: Number,
            required: true
        },
        totalCostProject: {
            type: Number,
            required: true
        },
        ctma: {
            type: Boolean,
            required: true
        },
        fg: {
            type: Boolean,
            required: true
        },
        ProjectSalarieCost: {
            type: Number,
            required: true
        },
    },
    computed: {
        filteredDataObj() {
            return this.refFI.filter(option => {
                return (
                    option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.filterBox.toLowerCase()) >= 0
                )
            })
        }
    },
    data() {
        return {
            // Set default values
            payload: {
                pclock: true,
                tauxfg: this.fg ? 20 : 0,
                percent: 0,
                cost: 0
            },
            filterBox: '',
        };
    },
    methods: {
        addFI() {
            // console.log(this.payload)
            if (this.payload.fi !== undefined &&
                this.payload.fi !== null &&
                parseFloat(this.payload.cost) >= 0) {
                this.payload.cost = parseFloat(this.payload.cost);
                this.payload.tauxfg = parseFloat(this.payload.tauxfg);
                this.payload.percent = parseFloat(this.payload.percent);
                this.$emit("add-fi", this.payload);
            } else {
                this.$buefy.snackbar.open(
                    {
                        message: `Mauvaise saisie, merci de vérifier`,
                        type: 'is-danger',
                        position: 'is-bottom-left'
                    });
            }


        },
        calcEuro() {
            this.payload.cost =
                this.ctma ?
                    this.totalCostProject * (this.payload.percent / 100)
                    :
                    (this.ProjectSalarieCost * (this.payload.percent / 100) * (this.payload.tauxfg / 100)) +
                    (this.totalCostProjectSansFG * (this.payload.percent / 100))
        },
        calcPercent() {
            // console.log(this.totalCostProject)
            // let fg = (this.ProjectSalarieCost / this.totalCostProjectSansFG) * parseFloat(this.payload.cost) * (this.payload.tauxfg/100)
            let pc = this.payload.cost / (this.payload.tauxfg/100 * this.ProjectSalarieCost + this.totalCostProjectSansFG)
            this.payload.percent =
                this.ctma ?
                    this.payload.cost * 100 / this.totalCostProject
                    :
                    // this.payload.cost * 100 / this.totalCostProjectSansFG
                    // Updated formula from Natacha
                    pc*100
        },
    }
};
</script>

<style scoped></style>
